import { createTypes, createActions, createReducer, createSelector } from './util'
import _ from 'lodash/fp'

const namespace = 'profile'

const typeKeys = [
  'CLEAR',
  'LOAD_REQUEST',
  'LOAD_REQUEST_DONE',
  'LOAD_SUCCESS',
  'LOAD_ERROR',
  'SAVE_REQUEST',
  'SAVE_REQUEST_DONE',
  'SAVE_SUCCESS',
  'SAVE_ERROR',
  'FLIP_HANDICAP_COMPARISON'
]

export const types = createTypes(typeKeys, namespace)

export const actions = createActions(types)

export const initialState = {
  items: {
    // what's loaded from the server
  },
  // load
  loadError: null,
  loadedAt: null,
  handicapComparison: false
}

const reducer = {
  [types.FLIP_HANDICAP_COMPARISON]: p => _.update('handicapComparison', (hc) => !hc),
  [types.CLEAR]: p => _.constant(initialState),
  [types.LOAD_REQUEST]: p => _.flow(
    _.set('loadRequestWaiting', true),
    _.set('loadError', null)
  ),
  [types.LOAD_REQUEST_DONE]: p => _.set('loadRequestWaiting', false),
  [types.LOAD_SUCCESS]: p => _.flow(
    _.set('items', p),
    _.set('loadedAt', Date.now()),
    _.set('picture', {}),
    _.set('pictureError', false),
    _.set('pictureSuccess', false)
  ),
  [types.LOAD_ERROR]: p => _.set('loadError', _.getOr(true, 'error', p)),
  [types.SAVE_REQUEST]: p => _.flow(
    _.set('saveRequestWaiting', true),
    _.set('saveError', false),
    _.set('saveSucces', false)
  ),
  [types.SAVE_REQUEST_DONE]: p => _.flow(
    _.set('saveRequestWaiting', false)
  ),
  [types.SAVE_SUCCESS]: p => _.flow(
    _.set('saveSuccess', Date.now())
  ),
  [types.SAVE_ERROR]: p => _.flow(
    _.set('saveError', { error: p, time: Date.now() })
  )

}

export default createReducer(initialState, reducer)

function createSelectors () {
  const getProfile = _.get('profile.items')
  const saveWaiting = _.get('profile.saveRequestWaiting')
  const saveSuccess = _.get('profile.saveSuccess')
  const saveError = _.get('profile.saveError')
  const getProfileId = createSelector(getProfile, _.get('id'))
  const getProfileHandle = createSelector(getProfile, _.get('handle'))
  const isUserLoaded = createSelector(getProfile, _.negate(_.isEmpty))
  const handicapComparison = _.get('profile.handicapComparison')
  const loadError = _.get('profile.loadError')

  return {
    getProfile,
    saveWaiting,
    saveSuccess,
    saveError,
    getProfileId,
    getProfileHandle,
    isUserLoaded,
    handicapComparison,
    loadError
  }
}

export const selectors = createSelectors()
